import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '@/store'

import Home from '@/components/Home.vue'
import Login from '@/components/Login.vue'
import NotFound from '@/components/NotFound.vue'
import HelloWorld from '@/components/HelloWorld'
import SlottingDashboard from '@/components/Slotting/Dashboard'
import SlottingTransactionOverview from '@/components/Slotting/Transactions/Overview'
import SlottingProductOverview from '@/components/Slotting/Products/Overview'
import SlottingProductSales from '@/components/Slotting/Products/Product'
import SlottingReports from '@/components/Slotting/Reports'
import SlottingTransactionUserOverview from '@/components/Slotting/TransactionUsers/Overview'
import RentalDashboard from '@/components/Rental/Dashboard'
import RentalProductOverview from '@/components/Rental/Products/Overview'
import RentalLocationOverview from '@/components/Rental/Locations/Overview'
import RentalLocation from '@/components/Rental/Locations/Location'
import RentalTransactionOverview from '@/components/Rental/Transactions/Overview'
import RentalProductSales from '@/components/Rental/Products/Product'
import RentalReports from '@/components/Rental/Reports'
import RentalMonthlyReports from '@/components/Rental/MonthlyReports/Overview'
import RentalFranchiseeReports from '@/components/Rental/FranchiseeReports/Overview'
import RentalTransactionUserOverview from '@/components/Rental/TransactionUsers/Overview'
import LicensorDashboard from '@/components/Licensor/Dashboard'
import LicensorProductOverview from '@/components/Licensor/Products/Overview'
import LicensorLocationOverview from '@/components/Licensor/Locations/Overview'
import LicensorLocation from '@/components/Licensor/Locations/Location'
import LicensorTransactionOverview from '@/components/Licensor/Transactions/Overview'
import LicensorProductSales from '@/components/Licensor/Products/Product'
import LicensorReports from '@/components/Licensor/Reports'
import LicensorTransactionUserOverview from '@/components/Licensor/TransactionUsers/Overview'
import LogisticsLocationOverview from '@/components/Logistics/Locations/Overview'
import LogisticsLocation from '@/components/Logistics/Locations/Location'
import MemberOverview from '@/components/Rental/Members/Overview'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: Login
  },
  {
    path: '/logout',
    beforeEnter: () => {
      store.commit('LOGOUT')
      router.replace('/login')
    }
  },
  {
    path: '/',
    component: Home,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/',
        name: 'HelloWorld',
        component: HelloWorld,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/slotting/dashboard',
        component: SlottingDashboard,
        name: 'SlottingDashboard',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/slotting/transactions',
        component: SlottingTransactionOverview,
        name: 'SlottingTransactionOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/slotting/products',
        component: SlottingProductOverview,
        name: 'SlottingProductOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/slotting/products/:id',
        component: SlottingProductSales,
        name: 'SlottingProductSales',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/slotting/reports',
        component: SlottingReports,
        name: 'SlottingReports',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/slotting/customers',
        component: SlottingTransactionUserOverview,
        name: 'SlottingTransactionUserOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/dashboard',
        component: RentalDashboard,
        name: 'RentalDashboard',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/products',
        component: RentalProductOverview,
        name: 'RentalProductOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/products/:id',
        component: RentalProductSales,
        name: 'RentalProductSales',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/locations',
        component: RentalLocationOverview,
        name: 'RentalLocationOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/locations/:id',
        component: RentalLocation,
        name: 'RentalLocation',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/transactions',
        component: RentalTransactionOverview,
        name: 'RentalTransactionOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/reports',
        component: RentalReports,
        name: 'RentalReports',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/monthly-reports',
        component: RentalMonthlyReports,
        name: 'RentalMonthlyReports',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/franchisee-reports',
        component: RentalFranchiseeReports,
        name: 'RentalFranchiseeReports',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/rental/customers',
        component: RentalTransactionUserOverview,
        name: 'RentalTransactionUserOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/licensor/dashboard',
        component: LicensorDashboard,
        name: 'LicensorDashboard',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/licensor/products',
        component: LicensorProductOverview,
        name: 'LicensorProductOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/licensor/products/:id',
        component: LicensorProductSales,
        name: 'LicensorProductSales',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/licensor/locations',
        component: LicensorLocationOverview,
        name: 'LicensorLocationOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/licensor/locations/:id',
        component: LicensorLocation,
        name: 'LicensorLocation',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/licensor/transactions',
        component: LicensorTransactionOverview,
        name: 'LicensorTransactionOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/licensor/reports',
        component: LicensorReports,
        name: 'LicensorReports',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/licensor/customers',
        component: LicensorTransactionUserOverview,
        name: 'LicensorTransactionUserOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/logistics/locations',
        component: LogisticsLocationOverview,
        name: 'LogisticsLocationOverview',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/logistics/locations/:id',
        component: LogisticsLocation,
        name: 'LogisticsLocation',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/member_management',
        component: MemberOverview,
        name: 'MemberOverview',
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '*',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.token) {
      next()
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js